/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Role_Badge_AdminInputs */

const en_admin_user_list_role_badge_admin = /** @type {(inputs: Admin_User_List_Role_Badge_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`admin`)
};

const de_admin_user_list_role_badge_admin = /** @type {(inputs: Admin_User_List_Role_Badge_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

/**
* | output |
* | --- |
* | "admin" |
*
* @param {Admin_User_List_Role_Badge_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_role_badge_admin = /** @type {((inputs?: Admin_User_List_Role_Badge_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Role_Badge_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_role_badge_admin(inputs)
	return en_admin_user_list_role_badge_admin(inputs)
});